import script from "./Description.vue?vue&type=script&setup=true&lang=js"
export * from "./Description.vue?vue&type=script&setup=true&lang=js"

import "./Description.vue?vue&type=style&index=0&id=2f85d61a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f85d61a"]])

export default __exports__